import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isNil } from 'lodash';

import { Space } from 'antd';
import { Button, TextInput } from '@life-line-lab/components-react';

import './verification-form.scss';

interface VerificationFormProps {
  status?: string;
  resErr?: any;
  onSubmit: (input: any) => void;
}

const VerificationForm: React.FC<VerificationFormProps> = ({ status, resErr, onSubmit }) => {
  const history = useHistory();
  const arr = [0,0,0,0];
  const arrLength = arr.length;

  const [elRefs, setElRefs] = useState<any[]>([]);
  const { t } = useTranslation();
  const [input, setInput] = useState<any>({});

  useEffect(() => {
    if (status === 'error') setInput({});
    else if (status === 'success') {
      history.push('/login');
    }
  }, [status])

  useEffect(() => {
    setElRefs(elRefs => (
      arr.map((_, i) => elRefs[i] || React.createRef())
    ));
  }, [arrLength]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    const pattern = new RegExp('^[0-9]*$', 'i');

    if (!isNil(e.target.value) && pattern.test(e.target.value)) {
      setInput({ ...input, [e.target.name]: e.target.value });

      if (i < arrLength - 1) {
        i++;
        elRefs[i].current!.focus({ cursor: 'start' });
      }
    }
  };

  const handleSubmit = () => {
    let code: string = '';
    arr.map((_, i) => code += input[i]);
    onSubmit(code)
}

   return (
     <div className="verification-form">
        <form>
          <Space direction="horizontal">
            {arr.map((el, i) => (
              <div key={i}>
                <TextInput
                  className="inp--code"
                  inputRef={elRefs[i]}
                  name={`${i}`}
                  value={input[i]}
                  maxLength={1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange(e, i)
                  }
                />
              </div>
            ))}
          </Space>

          <div className="form--actions center">
            <Button
              isLoading={status === "loading"}
              type="primary"
              ariaLabel={t('action.submit')}
              label={t('action.submit')}
              size="large"
              onClick={handleSubmit}
            />
          </div>
        </form>
     </div>
   )
}

export default VerificationForm;
